import { makeStyles } from '@material-ui/core/styles';
import { SIDE_COLUMN_PULL_UP } from 'core/components/layout-with-sidebar/layout-with-sidebar.styles';

const useStyles = makeStyles((theme) => ({
  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  // LayoutWithSidebar pulls the side column up under the page header; this keeps the first
  // section clear of it, matching the Modify Quote left column.
  // The pull-up less the column gap starts the first section level with the content column.
  columnHeader: {
    height: SIDE_COLUMN_PULL_UP - theme.spacing(2)
  },
  factsCard: {
    padding: theme.spacing(5, 6)
  }
}));

export default useStyles;
